// src/api/market.js
// API utility for market session awareness

export async function getMarketSession() {
  const response = await fetch("/market/session");
  if (!response.ok) throw new Error("Failed to fetch market session");
  return response.json();
}

export async function getIsMarketOpen() {
  const response = await fetch("/market/is-open");
  if (!response.ok) throw new Error("Failed to fetch market open status");
  return response.json();
}
